import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import ScrollProgress from "@/components/site/ScrollProgress";
import MobileStickyCTA from "@/components/site/MobileStickyCTA";
import Team from "@/components/site/Team";
import useDocumentMeta from "@/hooks/useDocumentMeta";
import { organizationSchema, breadcrumbSchema, SITE_URL, OG_IMAGES } from "@/lib/seo";

export default function TeamPage() {
  useDocumentMeta({
    title: "Leadership & Clinical Team | Integrated Wellness",
    description:
      "Meet the clinicians, advisers and operators behind Integrated Wellness — full biographies of the leadership and clinical team.",
    image: OG_IMAGES.team,
    url: `${SITE_URL}/team`,
    schema: [
      organizationSchema(),
      breadcrumbSchema([
        { name: "Home", url: "/" },
        { name: "Team", url: "/team" },
      ]),
    ],
  });

  return (
    <div data-testid="team-page" className="min-h-screen bg-background">
      <ScrollProgress />
      <Header />
      <main className="pt-16 md:pt-20">
        <Team />
      </main>
      <Footer />
      <MobileStickyCTA />
    </div>
  );
}
